export const Attribute = {
    Create: "CREATE",
    Delete: "DELETE",
    View: "VIEW",
    Update: "UPDATE",
};

export const ReportAttribute = {
    ViewLimited: "VIEW_LIMITED",
    ViewUsers: "VIEW_USERS",
    AddUser: "ADD_USER",
    AddCompanyUser: "ADD_COMPANY_USER",
    RemoveUser: "REMOVE_USER",
    ViewUserInvites: "VIEW_USER_INVITES",
    InviteUser: "INVITE_USER",
    CreateReportVulnerability: "CREATE_REPORT_VULNERABILITY",
};

export const ReportVersionAttribute = {
    Transition: "TRANSITION",
    ViewReadReceipts: "VIEW_READ_RECEIPTS",
    CreateDeliverableFile: "CREATE_DELIVERABLE_FILE",
    CreateTestTypePrerequisite: "CREATE_TEST_TYPE_PREREQUISITE",
    SendCustomEmail: "SEND_CUSTOM_EMAIL",
    SendDailyTestEmail: "SEND_DAILY_TEST_EMAIL",
    SendRequestInformationEmail: "SEND_REQUEST_INFORMATION_EMAIL",
};

export const CompanyAttribute = {
    ViewUsers: "VIEW_USERS",
    AddUser: "ADD_USER",
    RemoveUser: "REMOVE_USER",
    ViewUserInvites: "VIEW_USER_INVITES",
    InviteUser: "INVITE_USER",
    CreateReport: "CREATE_REPORT",
};

export const ReportVulnerabilityAttribute = {
    Transition: "TRANSITION",
    CreateAction: "CREATE_ACTION",
    CanCreateFile: "CREATE_FILE",
    CreateClientNotification: "CREATE_CLIENT_NOTIFICATION",
};

export const ReportAccessInformationAttribute = {
    CanCreateFile: "CREATE_FILE",
    CanCreateCredentials: "CREATE_CREDENTIALS",
    CanViewCredentials: "VIEW_CREDENTIALS",
};

export const ReportTestTypePrerequisiteAttribute = {
    CanComplete: "COMPLETE",
};
